module.exports = "7403e8fe7de8d0ad2f3f06c98bb1048e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/kirigami-bottom-shadow.png
// module id = 33
// module chunks = 0